import { useRequirementsStore } from "@/frontend/store/RequirementsStore";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { TEST_METHOD_OPTIONS, TestMethod } from "@/backend/access/requirementTestMethodAssignment/types";
import { I18n } from "@/i18n/I18n";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";
import { RequirementParams } from "@/backend/access/requirement/types";

interface RequirementTestMethodAssignmentsProps {
  requirement: RequirementParams;
}

export function RequirementTestMethodAssignments({ requirement }: RequirementTestMethodAssignmentsProps) {
  const assignments = useRequirementsStore(useShallow(state => state.testMethodAssignmentsByRequirement[requirement.id] || []));
  const fetchTestMethodAssignmentsByRequirementId = useRequirementsStore(state => state.fetchTestMethodAssignmentsByRequirementId);
  const createTestMethodAssignment = useRequirementsStore(state => state.createTestMethodAssignment);
  const deleteTestMethodAssignment = useRequirementsStore(state => state.deleteTestMethodAssignment);
  
  const userClass = useGlobalStore(state => state.userClass);
  const canEditTestMethods = requirement.propelOrgId === userClass?.getOrgId();

  useEffect(() => {
    void fetchTestMethodAssignmentsByRequirementId(requirement.id);
  }, [requirement.id, fetchTestMethodAssignmentsByRequirementId]);

  const selectedTestMethods = assignments.map(a => a.testMethod);

  const handleToggle = async (testMethod: TestMethod) => {
    const isSelected = selectedTestMethods.includes(testMethod);
    if (isSelected) {
      const assignment = assignments.find(a => a.testMethod === testMethod);
      if (assignment) {
        await deleteTestMethodAssignment(requirement.id, assignment.id);
      }
    } else {
      await createTestMethodAssignment(requirement.id, testMethod);
    }
  };

  return (
    <div className="mt-2">
      {!canEditTestMethods && <div className="form-label-neutral">{I18n.get('verificationMethod')}</div>}
      {canEditTestMethods && <div className="form-label-neutral">{I18n.get('verificationMethodDescription')}</div>}
      <div className="mt-1 d-flex gap-2">
          {canEditTestMethods && TEST_METHOD_OPTIONS.map(option => {
            if(option.permission && !userClass?.fusaHasPermission(option.permission)) {
              return null;
            }
            
            const isSelected = selectedTestMethods.includes(option.value);
            return (
              <Button
                key={option.value}
                className={`fusa-btn-small ${isSelected ? 'btn-neutral-dark' : 'btn-neutral-middle'}`}
                size="sm"
                onClick={() => void handleToggle(option.value)}
                aria-pressed={isSelected}
              >
                {I18n.get(option.labelKey)}
              </Button>
            );
          })}
          {!canEditTestMethods && assignments.map(assignment => (
            <div key={assignment.id} className="badge text-bg-dark">{I18n.get(TEST_METHOD_OPTIONS.find(option => option.value === assignment.testMethod)?.labelKey || '')}</div>
          ))}
      </div>
    </div>
  );
}
